$(document).ready(function () {
    // Open modal
    $(document).on('click', '[data-trigger="modal"]', function () {
        var $triggerButton = $(this);
        var targetSelector = $triggerButton.data('target');
        var $modal = $(targetSelector); // Dynamically find the modal using the target selector
        var $modalVideoContainer = $modal.find('.modal-video-container');
        var videoUrl = $triggerButton.data('video');

        if (videoUrl) {
            var videoId, embedUrl;

            // Determine YouTube or Vimeo embed URL
            if (videoUrl.includes('youtube.com') || videoUrl.includes('youtu.be')) {
                videoId = videoUrl.split('v=')[1] || videoUrl.split('/')[3];
                embedUrl = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0';
            } else if (videoUrl.includes('vimeo.com')) {
                videoId = videoUrl.split('/')[3];
                embedUrl = 'https://player.vimeo.com/video/' + videoId + '?autoplay=1';
            }

            // Insert video into the modal container
            var videoEmbedHtml = '<iframe src="' + embedUrl + '" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>';
            $modalVideoContainer.html(videoEmbedHtml);
        }

        // Open the modal
        $modal.addClass('show')
            .attr('aria-expanded', 'true')
            .attr('tabindex', '0')
            .focus();
        $('body').addClass('overlay-expanded');
    });

    // Close modal
    $(document).on('click', '.modal-close', function () {
        var $modal = $(this).closest('.video-modal');
        var $modalVideoContainer = $modal.find('.modal-video-container');

        $modal.removeClass('show')
            .attr('aria-expanded', 'false')
            .attr('tabindex', '-1');
        $('body').removeClass('overlay-expanded');

        // Stop video from playing when modal closes
        $modalVideoContainer.html('');
    });

    // Close modal when pressing the Esc key (accessibility)
    $(document).on('keydown', function (event) {
        if (event.key === 'Escape' && $('.video-modal.show').length) {
            var $modal = $('.video-modal.show');
            var $modalVideoContainer = $modal.find('.modal-video-container');

            $modal.removeClass('show')
                .attr('aria-expanded', 'false')
                .attr('tabindex', '-1');
            $('body').removeClass('overlay-expanded');

            // Stop video from playing when modal closes
            $modalVideoContainer.html('');
        }
    });

    // Close modal when clicking outside of the modal
    $(document).on('click', function (event) {
        if ($('.video-modal.show').length && !$(event.target).closest('.modal-content').length && !$(event.target).is('[data-trigger="modal"]')) {
            var $modal = $('.video-modal.show');
            var $modalVideoContainer = $modal.find('.modal-video-container');

            $modal.removeClass('show')
                .attr('aria-expanded', 'false')
                .attr('tabindex', '-1');
            $('body').removeClass('overlay-expanded');

            // Stop video from playing when modal closes
            $modalVideoContainer.html('');
        }
    });
});
